import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ar-receipt-view',
  templateUrl: './ar-receipt-view.component.html',
  styleUrls: ['./ar-receipt-view.component.css']
})
export class ArReceiptViewComponent implements OnInit {
  title="Accounts Receivable Receipt";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/Pages/sales-orders/accounts-receivable-receipt/ar-receipt-view/ar-receipt-view.component.ts